import React, { useState } from 'react';
import { Tabs, Tab } from '@mui/material';

const FranchiseTabBar = (props) => {
  const {
    tabs, activeTab = 1, className, orientation = 'horizontal',
  } = props;
  const [selectedTab, setSelectedTab] = useState(activeTab);
  const handleTabClick = (e, value) => {
    setSelectedTab(value);
  };

  return (
    <Tabs
      orientation={orientation}
      className={className}
      value={selectedTab}
      variant="scrollable"
      scrollButtons={false}
      onChange={handleTabClick}>
      {tabs.map((tab) => (
        <Tab key={tab.value} {...tab} />
      ))}
    </Tabs>
  );
};

export { FranchiseTabBar };
